import store from '@/store'
import { hasPermission } from '@/utils/permission'

export default async (to, from, next) => {
  try {
    const permission = to.meta.permission
    if (to.name == 'AcceptInvite' || to.name == 'ResetPassword' || to.name == 'ForgotPassword') {
      return next()
    }
    if (store.getters['auth/isAuthenticated'] && to.name == 'Login') {
      return next('/')
    }
    if (to.meta.requiresAuth && !store.getters['auth/isAuthenticated']) {
      return next('/login')
    }
    // ensure settings are loaded BEFORE any check
    if (!store.state.settings.settingsLoaded && to.name !== 'Login') {
      await store.dispatch('settings/loadSettings')
    }

    const amazonChannelId = store.getters['settings/settings']?.amazon_channel_id
    const requiresAmazon = to.meta.requiresAmazon

     // ✅ 2. Detect OAuth callback in ANY route
    const status = to.query.status
    const stateFromQuery = to.query.state

     // ✅ Already connected → prevent going back to integration page
     //&& amazonChannelId
    // if (to.name === 'basic-settings' ) {
    //   return next('/')
    // }
    if (status) {
      if (status === 'success' && stateFromQuery) {
       
        store.commit('settings/SET_AMAZON_STATE', stateFromQuery)
        // ✅ show success modal
        store.commit('ui/SHOW_MODAL', {
          type: 'success',
          message: 'Amazon channel connected successfully'
        })
      } else {
        // ❌ failure case
        store.commit('ui/SHOW_MODAL', {
          type: 'error',
          message: 'Failed to connect Amazon channel'
        })
      }

      //✅ IMPORTANT: clean URL (remove query params)
      return next({
        path: '/',
        query: {},
        replace: true
      })
    }
    // 🚫 Not connected → redirect
    if (requiresAmazon && !amazonChannelId) {
      return next({ name: 'basic-settings' })
    }
    if (!permission) {
      return next()
    }
    const role = store.getters['users/role']
    const allowed = hasPermission(role, permission)

    if (!allowed) {
      return next('/')
    }
    next()
  } catch (error) {
   // console.error('Failed to load settings:', error)
    next(false) // cancel navigation if something breaks
  }

  // async function handleCheckOutForm() {
  //   const settings = store.getters['settings/settings']
  //   const checkout_settings = settings?.checkout_settings
  //   if (checkout_settings) {
  //     await store.dispatch('checkout/setCheckoutSettings', checkout_settings)
  //   }
  // }
}


